<template>
  <div class="saas-layout">
    <!-- Overlay for mobile when sidebar is open -->
    <div 
      class="sidebar-overlay" 
      v-if="!menuColapsado && isMobile" 
      @click="toggleMenu"
    ></div>

    <!-- Sidebar Component -->
    <aside class="saas-sidebar" :class="{ 'collapsed': menuColapsado, 'mobile-open': !menuColapsado && isMobile }">
      <MenuLateralComponents :colapsado="menuColapsado" :isMobile="isMobile" @toggle-menu="toggleMenu" @close-mobile="closeMobileMenu" />
    </aside>

    <!-- Main Content Area -->
    <main class="saas-main">
      <!-- Mobile Topbar with Hamburger (visible only on mobile) -->
      <header class="mobile-header d-flex d-md-none align-items-center justify-content-between">
        <div class="mobile-logo">
          <img src="https://pub-3f3d3f8847a94e1e89883126e9a8db4c.r2.dev/config/logo.png" alt="Servease Logo" />
        </div>
        <button class="hamburger-btn" @click="toggleMenu" aria-label="Toggle Menu">
          <i class="bi bi-list"></i>
        </button>
      </header>
      
      <!-- Content View -->
      <div class="content-wrapper">
        <slot />
      </div>
    </main>
  </div>
</template>

<script>
import MenuLateralComponents from './MenuLateralComponents.vue';

export default {
  name: 'LayoutAutenticado',
  components: {
    MenuLateralComponents
  },
  data() {
    return {
      menuColapsado: false,
      isMobile: false
    };
  },
  mounted() {
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkScreenSize);
  },
  methods: {
    toggleMenu() {
      this.menuColapsado = !this.menuColapsado;
    },
    closeMobileMenu() {
      if (this.isMobile) {
        this.menuColapsado = true;
      }
    },
    checkScreenSize() {
      const mobileBreakpoint = 768; // Bootstrap md breakdown
      this.isMobile = window.innerWidth < mobileBreakpoint;
      
      // Auto-collapse sidebar on smaller screens
      if (window.innerWidth < 1024) {
        this.menuColapsado = true;
      } else {
        this.menuColapsado = false;
      }
    }
  }
};
</script>

<style scoped>
/* Reset global defaults for layout wrapper */
.saas-layout {
  display: flex;
  min-height: 100vh;
  width: 100%;
  background-color: #FAFAF9; /* V2 Dashboard Background */
  overflow: hidden;
}

/* Sidebar Wrapper */
.saas-sidebar {
  width: 260px;
  background-color: #FFFFFF;
  border-right: 1px solid #E2E8F0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  flex-direction: column;
  z-index: 1040;
}

.saas-sidebar.collapsed {
  width: 80px;
}

/* Mobile Sidebar Behavior */
@media (max-width: 767.98px) {
  .saas-sidebar {
    position: fixed;
    top: 0;
    left: -280px;
    height: 100vh;
    width: 280px;
    box-shadow: 4px 0 24px rgba(0,0,0,0.1);
  }

  .saas-sidebar.mobile-open {
    left: 0;
  }
  
  .saas-sidebar.collapsed {
    width: 280px; /* Reset on mobile so it purely relies on left positioning */
  }
}

/* Overlay for Mobile */
.sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(15, 23, 42, 0.5);
  backdrop-filter: blur(2px);
  z-index: 1030;
}

/* Main Content */
.saas-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
}

/* Mobile Header */
.mobile-header {
  background: #FFFFFF;
  border-bottom: 1px solid #E2E8F0;
  padding: 1rem 1.5rem;
  position: sticky;
  top: 0;
  z-index: 1020;
}

.mobile-logo img {
  height: 32px;
  object-fit: contain;
}

.hamburger-btn {
  background: transparent;
  border: none;
  font-size: 1.75rem;
  color: #334155;
  cursor: pointer;
  padding: 0;
}

/* Scrollable Inner Content Container */
.content-wrapper {
  flex: 1;
  padding: 2rem;
  max-width: 1440px;
  margin: 0 auto;
  width: 100%;
}

@media (max-width: 767.98px) {
  .content-wrapper {
    padding: 1.25rem;
  }
}
</style>
